module.exports = __webpack_public_path__ + "placa_td_loja_s_juros_1x9_carne.png?872d46d622ebfb7ba51e9d81224f9ea6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_td_loja_s_juros_1x9_carne.png
// module id = 133
// module chunks = 0